/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Credits} from '../models/Credits';
import type {Error} from '../models/Error';

export interface UpdateCreditBalance$Request {
    accountId: number;
    credits?: Credits;
}

export interface UpdateCreditBalance$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateCreditBalanceRequest = createAction<PayloadData<void, UpdateCreditBalance$Request>>('CREDIT_CONTROLLER__UPDATE_CREDIT_BALANCE__REQUEST');
export const updateCreditBalanceSuccess = createAction<PayloadData<void, UpdateCreditBalance$Request>>('CREDIT_CONTROLLER__UPDATE_CREDIT_BALANCE__SUCCESS');
export const updateCreditBalanceFailure = createAction<PayloadData<Error, UpdateCreditBalance$Request, true>>('CREDIT_CONTROLLER__UPDATE_CREDIT_BALANCE__FAILURE');

export const updateCreditBalanceActions = [
    updateCreditBalanceRequest,
    updateCreditBalanceSuccess,
    updateCreditBalanceFailure
] as const;

/**
 * Update Credit Balance
 * @param {number} meta.accountId Id of account
 * @param {Credits} [meta.credits]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateCreditBalance = (meta: UpdateCreditBalance$Request, config?: UpdateCreditBalance$Config) => {
    return {
        CALL_API: {
            types: updateCreditBalanceActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/api-v2/${meta.accountId}/credits`,
            TRANSPORT_REQUEST_BODY: meta.credits,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

